import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import TablePagination from "@material-ui/core/TablePagination";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import CustomPaginatorActions from "../components/CustomPaginatorActions";

import { ROWS_PER_PAGE_OPTIONS } from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";

import CancelIcon from "@material-ui/icons/CancelOutlined";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  pdfDiv: {
    height: "calc(100% - 180px)",
    zIndex: 1,
    position: "fixed",
    top: `180px`,
    left: `0px`,
    right: "0px",
  },

  content: {
    backgroundColor: "white",
    opacity: "1",
  },
});

class ViewPdf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      errorString: "",
      notifyString: "",
      waiting: false,
      totalCount: 0,
      page: 0,
      rowsPerPage: 0,
      showPdf: false,
      useUrl: "",
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleMenuButtonClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = (event) => {
    this.setState({ anchorEl: null });
  };

  handleMenuSelection = (event, option) => {
    this.setState({ rowsPerPage: option });
    this.setState({ page: 0 });
    this.setState({ anchorEl: null });
    this.generateReport(option, 0);
  };

  handleClose(e) {
    e.preventDefault();
    fetch("on_delete_pdf_report", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        this.props.onClosePopup(e);
      })
      .catch((error) => {
        this.props.onClosePopup(e);
      });
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
    this.generateReport(this.state.rowsPerPage, page);
  };

  componentDidMount() {
    this.setState({ page: this.props.page });
    this.setState({ rowsPerPage: this.props.rowsPerPage });
    this.generateReport(this.props.rowsPerPage, this.props.page);
  }

  generateReport(curRowsPerPage, curPage) {
    if (this.props.postData) {
      this.generatePostReport(curRowsPerPage, curPage);
      return;
    }
    this.setState({ waiting: true });
    this.setState({ showPdf: false });

    fetch(this.getUrl(curRowsPerPage, curPage), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
        rowsPerPage: curRowsPerPage,
        page: curPage,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ waiting: false });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
          } else {
            let totCount = reply.totalCount;
            this.setState({ totalCount: totCount });
            this.setState({
              useUrl:
                "on_fetch_pdf_report",
            });
            this.setState({ showPdf: true });
          }
        }
      })
      .catch((error) => {
        this.setState({ waiting: false });
        this.setState({ totalCount: 0 });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  generatePostReport(curRowsPerPage, curPage) {
    let postData = this.props.postData;
    postData.page = curPage;
    postData.rowsPerPage = curRowsPerPage;
    this.setState({ waiting: true });
    this.setState({ showPdf: false });
    fetch(this.props.pdfUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          this.setState({ waiting: false });
          if (reply.error) {
            this.setState({ errorString: reply.errorString });
          } else if (reply.warning) {
            this.setState({ notifyString: reply.warningString });
          } else {
            let totCount = reply.totalCount;
            this.setState({ totalCount: totCount });
            this.setState({
              useUrl:
                "on_fetch_pdf_report",
            });
            this.setState({ showPdf: true });
          }
        }
      })
      .catch((error) => {
        this.setState({ waiting: false });
        this.setState({ totalCount: 0 });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  getUrl(curRowsPerPage, curPage) {
    return this.props.pdfUrl;
  }

  render() {
    const { classes } = this.props;
    let { t } = this.props;
    let anchorEl = this.state.anchorEl;
    return (
      <div style={{ opacity: "1" }}>
        <Dialog
          open
          fullScreen={true}
          PaperProps={{
            classes: {
              root: classes.content,
            },
          }}
        >
          <DialogContent className={classes.pdfDiv}>
            <div id="myPdf" className={classes.pdfDiv}>
              {this.state.showPdf && (
                <embed
                  src={this.state.useUrl}
                  type="application/pdf"
                  style={{ width: "100%", height: "100%" }}
                />
              )}
            </div>
          </DialogContent>
          <DialogActions style={{ display: "flex", justifyContent: "center" }}>
            <Button color="primary" onClick={this.handleClose}>
              <CancelIcon />
              &nbsp;{t("closePdf.button")}
            </Button>
          </DialogActions>
          {!this.state.waiting && this.state.totalCount > 0 && (
            <DialogActions
              style={{
                display: "flex",
                justifyContent: "center",
                opacity: "1",
              }}
            >
              {this.props.nopagination !== "yes" && (
                <div>
                  <Typography variant="caption">
                    {t("rows.label")}
                    <Button
                      aria-owns={anchorEl ? "simple-menu" : null}
                      aria-haspopup="true"
                      onClick={this.handleMenuButtonClick}
                    >
                      <Typography variant="caption">
                        {this.state.rowsPerPage}
                      </Typography>
                      <ArrowDropDown />
                    </Button>
                  </Typography>
                  <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={this.handleMenuClose}
                    PaperProps={{
                      style: {
                        maxHeight: 120,
                      },
                    }}
                  >
                    {ROWS_PER_PAGE_OPTIONS.map((option) => (
                      <MenuItem
                        key={option}
                        selected={option === this.state.rowsPerPage}
                        onClick={(event) =>
                          this.handleMenuSelection(event, option)
                        }
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>
              )}
              {this.props.nopagination !== "yes" && (
                <TablePagination
                  component="div"
                  count={this.state.totalCount}
                  rowsPerPage={this.state.rowsPerPage}
                  rowsPerPageOptions={[]}
                  page={this.state.page}
                  SelectProps={{
                    style: {
                      maxHeight: "200px",
                      overflow: "auto",
                    },
                  }}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  ActionsComponent={CustomPaginatorActions}
                />
              )}
            </DialogActions>
          )}
          {!this.state.waiting &&
            this.state.errorString.length === 0 &&
            this.state.notifyString.length === 0 && (
              <p
                style={{ color: "primary", fontSize: 10, textAlign: "center" }}
              >
                {t("waitPdf.label")}{" "}
              </p>
            )}
          {this.state.waiting && (
            <p style={{ color: "primary", textAlign: "center" }}>
              {" "}
              {t("generatePdf.label")}{" "}
            </p>
          )}
          {this.state.errorString.length > 0 && (
            <p style={{ color: "red", textAlign: "center" }}>
              {" "}
              {"ERROR: " +
                this.state.errorString +
                ". Please close this view (click the above CLOSE PDF VIEW button)."}
            </p>
          )}
          {this.state.notifyString.length > 0 && (
            <p style={{ color: "primary", textAlign: "center" }}>
              {" "}
              {this.state.notifyString +
                ". Please close this view (click the above CLOSE PDF VIEW button)."}
            </p>
          )}
        </Dialog>
      </div>
    );
  }
}
export default withTranslation()(withStyles(styles)(ViewPdf));
